import { TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";

const User = ({info}) => {

    const history = useHistory()
    const editHandler = (e) => {
        e.preventDefault()
        history.push(`/user/${info.user.userid}`)
    }

    return(
        <>
            <TableRow key={info.user.userid} onClick={editHandler} className='pointer' >
                <TableCell >{info.user.username}</TableCell>
                <TableCell align="right">{info.user.fname}</TableCell>
                <TableCell align="right">{info.user.mname}</TableCell>
                <TableCell align="right">{info.user.lname}</TableCell>
                <TableCell align="right">{info.user.points}</TableCell>
            </TableRow>
        </>    
    )
}

export default User;